export var to = function to(breakpoint) {
  return function (_ref) {
    var theme = _ref.theme;

    if (theme.variables.breakpoints[breakpoint] === undefined && theme.variables.customBreakpoints[breakpoint] === undefined) {
      throw new Error('Undefined breakpoint');
    }

    return "@media (max-width: ".concat((theme.variables.breakpoints[breakpoint] || theme.variables.customBreakpoints[breakpoint]) - 1, "px)");
  };
};